import React, { useState } from "react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import LoaderAnimation from "./LoaderAnimationLarge";

const AddPatientRegister = () => {
  const [loading, setLoading] = useState(false);
  const [patientfullname, setpatientfullname] = useState("");
  const [patientgender, setpatientgender] = useState("");
  const [patientdateofbirth, setpatientdateofbirth] = useState("");
  const [patientphonenumber, setpatientphonenumber] = useState("");
  const [patientemail, setpatientemail] = useState("");

  if (loading) {
    return <LoaderAnimation />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = {
        type: [{ target_id: "patient" }], // The machine name of the patient content type
        title: [{ value: patientfullname }],
        field_gender: [{ value: patientgender }],
        field_date_of_birth: [{ value: patientdateofbirth }],
        field_patient_phone_number: [{ value: patientphonenumber }],
        field_patient_email_address: [{ value: patientemail }],
      };

      const response = await fetch("/node?_format=json", {
        method: "POST",
        headers: {
          Authorization: `Basic ${btoa("salisu:abc@123@Q")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert("Patient added successfully!");
        setpatientdateofbirth("");
        setpatientgender("");
        setpatientphonenumber("");
        setpatientfullname("");
        setpatientemail("");
        setLoading(false);
      } else {
        const error = await response.json();
        alert(`Error:", ${error.message}`);
        setLoading(false);
      }
    } catch (error) {
      console.log("Network Error:", error);
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="add-patient-register">
          <TopActionMenus
            AddTitle="Add new patient"
            backStateKey="patientregister"
            backIcon={faArrowLeft}
            backLable="Back"
          />
          <form onSubmit={handleSubmit} className="patient-form">
            <div className="form-group">
              <label htmlFor="title">Full Name</label>
              <input
                type="text"
                placeholder=" Enter patient full name"
                value={patientfullname}
                onChange={(e) => setpatientfullname(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="field_gender">Gender</label>
              <select
                value={patientgender}
                onChange={(e) => setpatientgender(e.target.value)}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="field_date_of_birth">Date of Birth</label>
              <input
                type="date"
                value={patientdateofbirth}
                onChange={(e) => setpatientdateofbirth(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="field_patient_phone_number">Contact Number</label>
              <input
                type="tel"
                placeholder=" Enter patient contact number"
                value={patientphonenumber}
                onChange={(e) => setpatientphonenumber(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="field_patient_email_address">Email Address</label>
              <input
                type="email"
                placeholder=" Enter patient email address"
                value={patientemail}
                onChange={(e) => setpatientemail(e.target.value)}
                required
              />
            </div>
            <div className="submitGroup">
              <button type="submit" disabled={loading}>
                {"Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default AddPatientRegister;
